/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import { useHistory, useParams } from 'react-router-dom'

import ModalPrice from './Modals/editPrice'
import ModalQuantity from './Modals/editQuantity'
import ProductRejectConfirmation from './ProductRejectConfirmation'
import useStyles from './products.styles'

import BackDrop from 'components/BackDrop'
import FiltersBox from 'components/FiltersBox/FiltersBox'
import {
  DownloadIcon,
  UploadIcon,
  PencilIcon,
  DeleteIcon,
  EyeIcon,
  DefaultImage,
} from 'components/icons/personalizedIcons'
import ImageTooltip from 'components/ImageTooltip'
import ModalContainer from 'components/ModalContainer'
import useCustomDialogAlert from 'components/useCustomDialogAlert'
import { LUEGOPAGO_VERTICAL_ID } from 'constants/appConstants'
import { PENDING_TRANSACTION } from 'constants/errorApi'
import {
  adminFilterDictionary,
  storeFilterDictionary,
  adminCommonMenuItems,
  adminNewTabMenuItems,
  adminEditedTabMenuItems,
  adminAllTabMenuItems,
  storeMenuItems,
  menuItemsDictionary,
  ITEM_HEIGHT,
  optionsMenu,
  VARIABLE_PRODUCT,
} from 'constants/productsConstants'
import { SUPER_ADMIN, CUSTOMER_SUPPORT } from 'constants/rolesConst'
import { routesLink } from 'constants/routesConsts'
import {
  MICROSERVICES_PRODUCTS,
  API_DELETE_MASSIVE_PRODUCTS,
  API_PREVIOUS_PRODUCT,
} from 'constants/urls'
import useAuthContext from 'contextApi/AuthContext'

import { rejectPendingPending } from 'services/productsSellerAdmin/product.sellerAdmin.service'
import convertToCurrencyCop from 'utils/convertToCurrencyCop'
import { textLabels } from 'utils/functions'
import DeleteConfirmation from 'views/Stores/DeleteConfirmation'
import ModalCategoriesImport from 'views/UploadProducts/ModalCategoriesImport'
import { RECHARGABLE_PRODUCT } from 'constants/productsConstants'

const Products = () => {
  const {
    userLoggedin: { sellerId, role },
    getAccessToken,
  } = useContext(useAuthContext)
  const { idSeller } = useParams()
  const isAdmin = [SUPER_ADMIN, CUSTOMER_SUPPORT].includes(role)
  const [rowsSelected, setRowsSelected] = useState([])
  const showDialogAlert = useCustomDialogAlert()

  const history = useHistory()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const [selectedProductRowData, setSelectedProductRowData] = useState(null)

  const [isLoading, setIsLoading] = useState(false)
  const [isOpenCategories, setIsOpenCategories] = useState(false)
  const [typeAction, setTypeAction] = useState(0)
  const [editionModals, setEditionModals] = useState({
    openModalPrice: false,
    openModalStock: false,
    openRejectModal: false,
  })
  const [dataToEdit, setDataToEdit] = useState({
    id: '',
    stockQuantity: '',
    promotions: '',
    regularPrice: '',
    checkTransport: false,
    verticals: [],
  })
  const [request, setRequest] = useState({
    Page: 1,
    PageSize: 10,
    FilterBy: isAdmin ? adminFilterDictionary.new.value : storeFilterDictionary.all.value,
    SearchBy: '',
    SellerId: isAdmin ? idSeller : sellerId || '',
  })
  const [dialogAlert, setDialogAlert] = useState({
    open: false,
    title: '',
    message: '',
    action: null,
    personalized: null,
  })
  const [products, setProducts] = useState([])
  const [filters, setFilters] = useState([])
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    pageSize: 10,
    totalPages: 0,
  })
  const [deleteAlert, setDeleteAlert] = useState({
    isOpen: false,
    title: '',
    message: '',
    productIds: [],
  })

  const onClickAddProduct = () => {
    history.push(`${routesLink.addProduct}`)
  }

  const getProducts = async () => {
    setIsLoading(true)
    try {
      const queryParams = new URLSearchParams(request)
      if (request.SearchBy.length <= 0) {
        queryParams.delete('SearchBy')
      }
      const { status, data: response } = await axios.get(
        request.FilterBy === adminFilterDictionary.edited.value
          ? `${MICROSERVICES_PRODUCTS}/pendingApprovals?${queryParams.toString()}`
          : `${MICROSERVICES_PRODUCTS}/paginatedLite?${queryParams.toString()}`
      )
      if (status === 200) {
        const { records, page, pageSize, totalPages } = response.pagination
        setProducts(response.data)
        setPagination({
          total: records,
          page,
          pageSize,
          totalPages,
        })
      } else {
        setProducts([])
        setPagination({
          total: 0,
          page: 1,
          pageSize: 10,
          totalPages: 0,
        })
      }
    } catch {
      setProducts([])
      setPagination({
        total: 0,
        page: 1,
        pageSize: 10,
        totalPages: 0,
      })
    } finally {
      setIsLoading(false)
      setRowsSelected([])
    }
  }

  const getFilters = async () => {
    setIsLoading(true)
    if (role === 'seller') {
      setFilters()
    } else {
      try {
        const response = await axios.get(`${MICROSERVICES_PRODUCTS}/filters`)
        if (response.status === 200) {
          setFilters(response.data)
        }
      } catch {
        setIsLoading(false)
      } finally {
        setIsLoading(false)
      }
    }
  }

  const showMenuItemsStatuses = () => {
    let menuItems = []
    if (isAdmin) {
      menuItems = menuItems.concat(adminCommonMenuItems)
      if (request.FilterBy === adminFilterDictionary.new.value) {
        menuItems = menuItems.concat(adminNewTabMenuItems)
      } else if (request.FilterBy === adminFilterDictionary.edited.value) {
        menuItems = menuItems.concat(adminEditedTabMenuItems)
      } else if (request.FilterBy === adminFilterDictionary.all.value) {
        menuItems = menuItems.concat(adminAllTabMenuItems)
      }
    } else {
      menuItems = storeMenuItems
    }

    return (
      <TextField
        id="actions"
        select
        className={classes.actionsButton}
        onChange={(e) => {
          e.preventDefault()
          setTypeAction(Number(e.target.value))
        }}
        SelectProps={{
          native: true,
        }}
        variant="outlined"
      >
        <option value="0">Seleccione</option>
        {menuItems.map((item) => (
          <option
            key={item.value}
            value={item.value}
            style={{ fontFamily: 'Red Hat Display Regular' }}
          >
            {item.label}
          </option>
        ))}
      </TextField>
    )
  }

  const dinamicEdition = async (data) => {
    const arrayData = Array.isArray(data) ? data : [data]
    if (arrayData.length === 0) return
    const queryParams = new URLSearchParams({
      sellerIdRequest: idSeller,
    })
    const axiosUpdateConfig = {
      url: `${MICROSERVICES_PRODUCTS}/${arrayData.length === 1 ? 'updateLite' : 'bulkLite'}${
        isAdmin ? `?${queryParams.toString()}` : ''
      }`,
      method: arrayData.length === 1 ? 'PATCH' : 'PUT',
      data: arrayData.length > 1 ? arrayData : arrayData[0],
    }
    setIsLoading(true)
    try {
      const response = await axios(axiosUpdateConfig)
      if (response.status === 200 || response.status === 201) {
        getProducts()
        if (!isAdmin) {
          getFilters()
        }
        showDialogAlert(
          true,
          '¡Cambio exitoso!',
          `Producto actualizado correctamente`,
          'Cerrar',
          '',
          true
        )
      }
    } catch (error) {
      if (error.data.toLowerCase() === PENDING_TRANSACTION.toLowerCase()) {
        showDialogAlert(
          true,
          'Procesando productos.',
          'Ya estamos aprobando otro lote de productos. Por favor, espera a que finalice para poder continuar.',
          'Cerrar'
        )
      } else {
        showDialogAlert(true, '¡Advertencia!', `No se pudo actualizar el producto`, 'Cerrar')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteProducts = async (productIds) => {
    setIsLoading(true)
    const ids = Array.isArray(productIds) ? productIds : [productIds]
    let url = ''
    if (ids.length === 0) return
    if (ids.length === 1) url += `${MICROSERVICES_PRODUCTS}/${ids[0]}`
    if (ids.length > 1) url += API_DELETE_MASSIVE_PRODUCTS
    const queryParams = new URLSearchParams({
      sellerIdRequest: idSeller,
    })
    const axiosDeleteConfig = {
      url: `${url}${isAdmin ? `?${queryParams.toString()}` : ''}`,
      method: ids.length === 1 ? 'DELETE' : 'POST',
      data: ids.length > 1 ? ids : null,
    }
    try {
      const response = await axios(axiosDeleteConfig)
      if (response.status === 200 || response.status === 201 || response.status === 204) {
        showDialogAlert(
          true,
          '¡Cambio exitoso!',
          ids.length === 1
            ? 'Producto eliminado correctamente'
            : `Se eliminaron ${ids.length} productos correctamente`,
          'Cerrar',
          '',
          true
        )
        getProducts()
        if (!isAdmin) {
          getFilters()
        }
      } else {
        showDialogAlert(
          true,
          '¡Advertencia!',
          ids.length === 1
            ? 'No se pudo eliminar el producto'
            : `No se pudieron eliminar ${ids.length} productos`,
          'Cerrar'
        )
      }
    } catch {
      showDialogAlert(
        true,
        '¡Advertencia!',
        ids.length === 1
          ? 'No se pudo eliminar el producto'
          : `No se pudieron eliminar ${ids.length} productos`,
        'Cerrar'
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleProductApproval = async (productId, actionType, rejectText) => {
    setIsLoading(true)
    try {
      let response
      const isEdited = request.FilterBy === adminFilterDictionary.edited.value
      if (actionType === 1) {
        if (isEdited) {
          response = await axios.post(`${MICROSERVICES_PRODUCTS}/approvePendingChanges`, productId)
        } else {
          const approvementBody = productId.map((id) => ({
            id,
            status: 'publish',
          }))
          response = await dinamicEdition(approvementBody)
        }
      } else {
        response = await rejectPendingPending(productId, rejectText)
      }
      if (
        (isEdited && response.status === 200) ||
        (!isEdited && (response.result.status === 200 || response.result.status === 201))
      ) {
        showDialogAlert(
          true,
          '¡Cambio exitoso!',
          response.message ||
            `Los productos se han ${actionType === 1 ? 'aprobado' : 'rechazado'} correctamente`,
          'Cerrar',
          '',
          true
        )
        getProducts()
        if (!isAdmin) {
          getFilters()
        }
      } else {
        showDialogAlert(
          true,
          '¡Advertencia!',
          response.message || `No se pudo ${actionType === 1 ? 'aprobar' : 'rechazar'} el producto`,
          'Cerrar'
        )
      }
    } catch (error) {
      console.error('Error approving/rejecting product:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleMenuActions = (selectedProducts) => {
    if (selectedProducts.length === 0) return

    switch (typeAction) {
      case menuItemsDictionary.delete_products:
        setDeleteAlert({
          isOpen: true,
          title: '¡Advertencia!',
          message:
            selectedProducts.length === 1
              ? `¿Está seguro que desea eliminar el producto "${
                  products.find((product) => product.id === selectedProducts[0]).name
                }"?`
              : `¿Está seguro que desea eliminar los (${selectedProducts.length}) productos seleccionados?`,
          productIds: selectedProducts.length === 1 ? [selectedProducts[0]] : selectedProducts,
        })
        break
      case menuItemsDictionary.set_out_of_stock: {
        const updateProductBody = selectedProducts.map((productId) => ({
          id: productId,
          stockQuantity: 0,
        }))
        dinamicEdition(updateProductBody)
        break
      }
      case menuItemsDictionary.turn_on_transport: {
        const updateProductBody = selectedProducts.map((productId) => ({
          id: productId,
          checkTransport: true,
        }))
        dinamicEdition(updateProductBody)
        break
      }
      case menuItemsDictionary.turn_off_transport: {
        const updateProductBody = selectedProducts.map((productId) => ({
          id: productId,
          checkTransport: false,
        }))
        dinamicEdition(updateProductBody)
        break
      }
      case menuItemsDictionary.product_approval:
        showDialogAlert(
          true,
          `Aprobación de productos`,
          `¿Está seguro que desea aprobar ${selectedProducts.length} productos?`,
          'Aceptar',
          'Cancelar',
          false,
          () => {
            handleProductApproval(selectedProducts, 1)
          }
        )
        break
      case menuItemsDictionary.product_decline:
        setDataToEdit(selectedProducts)
        setEditionModals({
          ...editionModals,
          openRejectModal: true,
        })
        break
      case menuItemsDictionary.turn_on_visibility: {
        const updateVisibilityOn = selectedProducts.map((productId) => {
          const newVerticalInfo = products
            .find((product) => product.id === productId)
            .verticals.map((vertical) => {
              if (vertical.vertical === LUEGOPAGO_VERTICAL_ID) {
                return {
                  ...vertical,
                  isActive: true,
                }
              }
              return vertical
            })
          return {
            id: productId,
            verticals: newVerticalInfo,
          }
        })
        dinamicEdition(updateVisibilityOn)
        break
      }
      case menuItemsDictionary.turn_off_visibility: {
        const updateVisibilityOff = selectedProducts.map((productId) => {
          const newVerticalInfo = products
            .find((product) => product.id === productId)
            .verticals.map((vertical) => {
              if (vertical.vertical === LUEGOPAGO_VERTICAL_ID) {
                return {
                  ...vertical,
                  isActive: false,
                }
              }
              return vertical
            })
          return {
            id: productId,
            verticals: newVerticalInfo,
          }
        })
        dinamicEdition(updateVisibilityOff)
        break
      }
      default:
        console.warn('Acción no reconocida:', typeAction)
        break
    }
  }

  const onClickProduct = (productId) => {
    if (isAdmin) {
      history.push(`${routesLink.adminEditProduct}/${productId}/${idSeller}`)
    } else {
      history.push(`${routesLink.editProduct}/${productId}`)
    }
  }

  const handleCloseDialog = () => {
    setDialogAlert({ ...dialogAlert, open: false })
  }

  const handleClose = async (option, productName, productId) => {
    setAnchorEl(null)
    try {
      switch (option) {
        case 'Editar':
          onClickProduct(productId)
          break
        case 'Eliminar':
          setDeleteAlert({
            isOpen: true,
            title: '¡Advertencia!',
            message: `¿Está seguro que desea eliminar el producto "${productName}"?`,
            productIds: [productId],
          })
          break
        case 'Restaurar versión':
          setDialogAlert({
            open: true,
            title: '¿Desea restaurar la última versión aprobada del producto?',
            message: `¿Está seguro que desea restaurar a la información previa aprobada del producto ${productName} ?`,
            action: async () => {
              try {
                setIsLoading(true)
                handleCloseDialog()
                const respuesta = await axios({
                  url: `${API_PREVIOUS_PRODUCT}/Restore/${productId}`,
                  method: 'PUT',
                })

                if (respuesta.status === 200) {
                  getProducts()
                  showDialogAlert(
                    true,
                    '¡Cambio exitoso!',
                    `Se ha restaurado a la última versión del producto ${productName}`,
                    'Cerrar',
                    '',
                    true
                  )
                }
              } catch (error) {
                setIsLoading(false)
              }
            },
          })
          break
        case 'Duplicar':
          history.push(`${routesLink.copyProduct}/${productId}`)
          break
        default:
          break
      }
    } catch {
      showDialogAlert(
        true,
        '¡Advertencia!',
        `No se pudo realizar la acción "${option}" en el producto "${productName}"`,
        'Cerrar'
      )
    }
  }

  useEffect(() => {
    const token = getAccessToken()
    if (!token) {
      history.push(routesLink.login)
    } else {
      if (isAdmin) return
      getFilters()
    }
  }, [])

  useEffect(() => {
    const token = getAccessToken()
    if (!token) {
      history.push(routesLink.login)
    } else {
      getProducts()
    }
  }, [request])

  return (
    <div>
      <BackDrop open={isLoading} />
      {isOpenCategories && (
        <ModalCategoriesImport
          isOpenModalCategories={isOpenCategories}
          setIsOpenModalCategories={setIsOpenCategories}
        />
      )}
      <Grid container justifyContent="space-between">
        <Typography variant="h6" style={{ color: '#6064FF' }}>
          {isAdmin ? 'Lista de productos de la tienda:' : 'Lista de productos'}
        </Typography>
        <Grid className={classes.divButtonsHeader}>
          {isAdmin ? (
            <Button
              onClick={() => history.push(routesLink.stores)}
              className={classes.btnNewProduct}
              variant="contained"
              color="secondary"
            >
              Regresar a las tiendas
            </Button>
          ) : (
            <>
              <IconButton
                className={classes.iconButton}
                onClick={() => history.push(routesLink.importProducts)}
              >
                <UploadIcon />
              </IconButton>
              <IconButton
                className={classes.iconButton}
                disabled={isLoading}
                onClick={(e) => {
                  e.preventDefault()
                  setIsOpenCategories(true)
                }}
              >
                <DownloadIcon />
              </IconButton>
              <Button
                onClick={onClickAddProduct}
                className={classes.btnNewProduct}
                variant="contained"
                color="secondary"
                style={{ fontFamily: 'Red Hat Display Bold' }}
              >
                Nuevo producto
              </Button>
            </>
          )}
        </Grid>
      </Grid>
      <Grid container direction="column" className={classes.divContent}>
        <FiltersBox
          handleSearch={(searchText) => {
            setRequest({
              ...request,
              Page: 1,
              SearchBy: searchText,
            })
          }}
          handleFilterClick={(filter) => {
            setRequest({
              ...request,
              Page: 1,
              SearchBy: '',
              FilterBy: filter,
            })
          }}
          filters={filters}
          activeFilter={request.FilterBy}
        />
        <MUIDataTable
          data={products}
          columns={[
            {
              name: 'id',
              options: {
                display: false,
              },
            },
            {
              name: 'images',
              options: {
                customHeadLabelRender: () => {
                  return null
                },
                customBodyRender: (value) => {
                  return value && value[0]?.src && value[0]?.src !== 'string' ? (
                    <ImageTooltip image={value[0].src} showImage />
                  ) : (
                    <DefaultImage />
                  )
                },
              },
            },
            {
              name: 'name',
              options: {
                customHeadLabelRender: () => {
                  return (
                    <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                      NOMBRE PRODUCTO
                    </th>
                  )
                },
                customBodyRender: (value, tableMeta) => {
                  return (
                    <Link
                      href={`${routesLink.editProduct}/${tableMeta.rowData[0]}`}
                      color="secondary"
                      onClick={(event) => {
                        event.preventDefault()
                        onClickProduct(tableMeta.rowData[0])
                      }}
                    >
                      <Typography variant="subtitle1">{value}</Typography>
                    </Link>
                  )
                },
              },
            },
            {
              name: 'sku',
              options: {
                customHeadLabelRender: () => {
                  return <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>SKU</th>
                },
                customBodyRender: (value) => {
                  return <div style={{ fontFamily: 'Red Hat Display Regular' }}>{value}</div>
                },
              },
            },
            {
              name: 'type',
              options: {
                customHeadLabelRender: () => {
                  return <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>TIPO</th>
                },
                customBodyRender: (value) => {
                  return <div style={{ fontFamily: 'Red Hat Display Regular' }}>{value}</div>
                },
              },
            },
            {
              name: 'regularPrice',
              options: {
                customHeadLabelRender: () => {
                  return (
                    <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>PRECIO</th>
                  )
                },
                customBodyRender: (value, tableMeta) => {
                  const productType = tableMeta.rowData[4]
                  return (
                    <>
                      {[VARIABLE_PRODUCT, RECHARGABLE_PRODUCT].includes(productType) ? (
                        <span>---</span>
                      ) : (
                        <div className={classes.adjustTable}>
                          <IconButton
                            className={classes.btnEdit}
                            onClick={() => {
                              setDataToEdit({
                                id: tableMeta.rowData[0],
                                regularPrice: value || 0,
                              })
                              setEditionModals({
                                ...editionModals,
                                openModalPrice: true,
                              })
                            }}
                          >
                            <PencilIcon />
                          </IconButton>
                          <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                            {`$${convertToCurrencyCop(value)}`}
                          </div>
                        </div>
                      )}
                    </>
                  )
                },
              },
            },
            {
              name: 'stockQuantity',
              options: {
                display: !isAdmin,
                customHeadLabelRender: () => {
                  return (
                    <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>CANTIDAD</th>
                  )
                },
                customBodyRender: (value, tableMeta) => {
                  const productType = tableMeta.rowData[6]

                  return (
                    <>
                      {productType === VARIABLE_PRODUCT ? (
                        <span>--</span>
                      ) : (
                        <div className={classes.adjustTable}>
                          <IconButton
                            className={classes.btnEdit}
                            onClick={() => {
                              setDataToEdit({
                                id: tableMeta.rowData[0],
                                stockQuantity: value || 0,
                              })
                              setEditionModals({
                                ...editionModals,
                                openModalStock: true,
                              })
                            }}
                          >
                            <PencilIcon />
                          </IconButton>

                          <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                            {convertToCurrencyCop(Number(value)) || 0}
                          </div>
                        </div>
                      )}
                    </>
                  )
                },
              },
            },
            {
              name: 'dateCreated',
              options: {
                customHeadLabelRender: () => {
                  return (
                    <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                      {request.FilterBy === adminFilterDictionary.edited.value
                        ? 'FECHA DE MODIFICACIÓN'
                        : 'FECHA DE CREACIÓN'}
                    </th>
                  )
                },
                customBodyRender: (value, tableMeta) => {
                  return (
                    <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                      {request.FilterBy === adminFilterDictionary.edited.value
                        ? tableMeta.rowData[10]?.split('T', 1)
                        : value?.split('T', 1)}
                    </div>
                  )
                },
              },
            },
            {
              name: 'verticals',
              options: {
                customHeadLabelRender: () => {
                  return (
                    <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>VISIBLE</th>
                  )
                },
                customBodyRender: (value, tableMeta) => {
                  const isActive = Boolean(
                    value?.find((vertical) => vertical.vertical === LUEGOPAGO_VERTICAL_ID)?.isActive
                  )
                  const productId = tableMeta.rowData[0]
                  const status = tableMeta.rowData[9]
                  return (
                    <FormControlLabel
                      className={classes.switchVisibility}
                      control={
                        <Switch
                          onChange={() => {
                            const newVerticalInfo = (value || []).map((vertical) => {
                              if (vertical.vertical === LUEGOPAGO_VERTICAL_ID) {
                                return {
                                  ...vertical,
                                  isActive: !isActive,
                                }
                              }
                              return vertical
                            })
                            dinamicEdition({
                              id: productId,
                              verticals: newVerticalInfo,
                            })
                          }}
                          checked={isActive}
                          disabled={status === 'draft'}
                          name="isVisible"
                          color="primary"
                          size="small"
                        />
                      }
                    />
                  )
                },
              },
            },
            {
              name: 'status',
              options: {
                display: false,
              },
            },
            {
              name: 'dateModified',
              options: {
                display: false,
              },
            },
            {
              name: '',
              label: '',
              options: {
                download: false,
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                  return !isAdmin ? (
                    <>
                      <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                          style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '38ch',
                            boxShadow: '-6px 6px #E8E8E8',
                            fontFamily: 'Red Hat Display Regular',
                          },
                        }}
                      >
                        {optionsMenu.map((option) => (
                          <MenuItem
                            key={option}
                            selected={option === 'Pyxis'}
                            onClick={(event) => {
                              event.preventDefault()
                              handleClose(
                                option,
                                selectedProductRowData.name,
                                selectedProductRowData.id
                              )
                            }}
                            style={{ fontFamily: 'Red Hat Display Regular' }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                      <Tooltip title="Editar">
                        <IconButton
                          className={classes.btnEdit}
                          onClick={(event) => {
                            event.preventDefault()
                            onClickProduct(tableMeta.rowData[0])
                          }}
                        >
                          <PencilIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Eliminar">
                        <IconButton
                          className={classes.btnDelete}
                          onClick={(event) => {
                            event.preventDefault()
                            setDeleteAlert({
                              isOpen: true,
                              title: '¡Advertencia!',
                              message: `¿Está seguro que desea eliminar el producto "${tableMeta.rowData[2]}"?`,
                              productIds: [tableMeta.rowData[0]],
                            })
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      <IconButton
                        onClick={(event) => {
                          setSelectedProductRowData({
                            id: tableMeta.rowData[0],
                            name: tableMeta.rowData[2],
                          })
                          setAnchorEl(event.currentTarget)
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <Tooltip title="ver Producto">
                        <IconButton
                          className={classes.btnEdit}
                          onClick={(event) => {
                            event.preventDefault()
                            onClickProduct(tableMeta.rowData[0])
                          }}
                        >
                          <EyeIcon />
                        </IconButton>
                      </Tooltip>
                      {request.FilterBy !== adminFilterDictionary.all.value && (
                        <Tooltip title="Aprobar producto">
                          <IconButton
                            className={classes.btnEdit}
                            disabled={rowsSelected.length > 0}
                            onClick={(event) => {
                              event.preventDefault()
                              setTypeAction(0)
                              showDialogAlert(
                                true,
                                `Aprobación de productos`,
                                `¿Está seguro que desea aprobar ${tableMeta.rowData[2]}?`,
                                'Aceptar',
                                'Cancelar',
                                false,
                                () => {
                                  handleProductApproval([tableMeta.rowData[0]], 1)
                                }
                              )
                            }}
                          >
                            <CheckIcon />
                          </IconButton>
                        </Tooltip>
                      )}

                      {request.FilterBy === adminFilterDictionary.new.value ? (
                        <Tooltip title="Eliminar">
                          <IconButton
                            className={classes.btnDelete}
                            onClick={(event) => {
                              event.preventDefault()
                              setDeleteAlert({
                                isOpen: true,
                                title: '¡Advertencia!',
                                message: `¿Está seguro que desea eliminar el producto "${tableMeta.rowData[2]}"?`,
                                productIds: [tableMeta.rowData[0]],
                              })
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                      {request.FilterBy === adminFilterDictionary.edited.value ? (
                        <Tooltip title="Rechazar producto">
                          <IconButton
                            className={classes.btnDelete}
                            disabled={rowsSelected.length > 0}
                            onClick={(event) => {
                              event.preventDefault()
                              setTypeAction(1)
                              setDataToEdit([tableMeta.rowData[0]])
                              setEditionModals({
                                ...editionModals,
                                openRejectModal: true,
                              })
                            }}
                          >
                            <ClearIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </>
                  )
                },
              },
            },
          ]}
          options={{
            selectableRows: true,
            rowsSelected: rowsSelected,
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelectedNow) => {
              setRowsSelected(allRowsSelected.map((row) => row.dataIndex) || [])
            },
            print: false,
            download: false,
            sort: false,
            page: pagination.page - 1,
            count: pagination.total,
            rowsPerPage: pagination.pageSize,
            rowsPerPageOptions: [10, 25, 50, 100],
            serverSide: true,
            filter: false,
            search: false,
            viewColumns: false,
            textLabels: textLabels(isLoading),
            tableBodyMaxHeight: '60vh',
            tableBodyHeight: '60vh',
            onChangePage: (currentPage) => {
              setRequest((prevState) => ({
                ...prevState,
                Page: currentPage + 1,
              }))
            },
            onChangeRowsPerPage: (rows) => {
              setRequest((prevState) => ({
                ...prevState,
                PageSize: rows,
                Page: 1,
              }))
            },
            customToolbarSelect: (selectedRows, displayData) => {
              return (
                <Grid
                  container
                  className={classes.toolBarSelect}
                  style={{ fontFamily: 'Red Hat Display Regular' }}
                >
                  {showMenuItemsStatuses()}
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.btnApply}
                    onClick={(e) => {
                      e.preventDefault()
                      const selectedData = selectedRows.data.map((row) => {
                        return displayData[row.index].data[0]
                      })
                      handleMenuActions(selectedData)
                    }}
                  >
                    Aplicar acción
                  </Button>
                </Grid>
              )
            },
          }}
        />
      </Grid>
      <ModalContainer
        title="Precio de producto"
        open={editionModals.openModalPrice}
        onClose={() => {
          setEditionModals({
            ...editionModals,
            openModalPrice: false,
          })
          setDataToEdit({})
        }}
        size="sm"
        disableBackdropClick
      >
        <ModalPrice
          data={dataToEdit}
          handleSubmit={(dataEdited) => {
            setEditionModals({
              ...editionModals,
              openModalPrice: false,
            })
            const formattedPrice = dataEdited.regularPrice.replace(/,/g, '')
            dinamicEdition({
              id: dataEdited.id,
              regularPrice: Number(formattedPrice),
            })
          }}
          onCancel={() => {
            setEditionModals({
              ...editionModals,
              openModalPrice: false,
            })
            setDataToEdit({})
          }}
        />
      </ModalContainer>
      <ModalContainer
        title="Actualizar cantidad"
        open={editionModals.openModalStock}
        onClose={() => {
          setEditionModals({
            ...editionModals,
            openModalStock: false,
          })
          setDataToEdit({})
        }}
        size="sm"
        disableBackdropClick
      >
        <ModalQuantity
          data={dataToEdit}
          handleSubmit={(dataEdited) => {
            setEditionModals({
              ...editionModals,
              openModalStock: false,
            })
            dinamicEdition({
              id: dataEdited.id,
              stockQuantity: dataEdited.stockQuantity,
            })
          }}
          onCancel={() => {
            setEditionModals({
              ...editionModals,
              openModalStock: false,
            })
            setDataToEdit({})
          }}
        />
      </ModalContainer>
      <DeleteConfirmation
        {...deleteAlert}
        onClose={() => setDeleteAlert({ isOpen: false })}
        onConfirm={() => {
          handleDeleteProducts(deleteAlert.productIds)
          setDeleteAlert({ isOpen: false })
        }}
      />
      <Dialog open={dialogAlert.open} onClose={handleCloseDialog}>
        <DialogTitle id="alert-dialog-title">{dialogAlert.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className={classes.titleModal}>
            {dialogAlert.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.groupButton}>
          <Button className={classes.btnBackgroundError} onClick={handleCloseDialog}>
            Cancelar
          </Button>
          <Button
            className={classes.btnBackgroundPrimary}
            variant="contained"
            color="secondary"
            autoFocus
            onClick={() => {
              dialogAlert.action()
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <ProductRejectConfirmation
        open={editionModals.openRejectModal}
        handleClose={() => {
          setEditionModals({
            ...editionModals,
            openRejectModal: false,
          })
        }}
        productsLength={dataToEdit.length}
        onConfirm={(rejectText) => {
          handleProductApproval(dataToEdit, 0, rejectText)
          setEditionModals({
            ...editionModals,
            openRejectModal: false,
          })
          setDataToEdit({})
        }}
      />
    </div>
  )
}

export default Products
